module.exports = __webpack_public_path__ + "static/media/search-1.fa36ffa8.png";